import { useNavigate } from 'react-router-dom';

export default function Location() {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('user');
    navigate('/login');
  };

  const openGoogleMaps = () => {
    const address = "Assembleia de Deus Missão Europa church Tv. do Parque 7, 2500-266 Caldas da Rainha, Portugal";
    const encodedAddress = encodeURIComponent(address);
    window.open(`https://www.google.com/maps/search/?api=1&query=${encodedAddress}`, '_blank');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-400 via-blue-500 to-purple-500">
      {/* Header */}
      <header className="bg-white/95 backdrop-blur-sm shadow-xl border-b-4 border-gradient-to-r from-green-600 to-blue-600">
        <div className="px-6 py-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4">
              <img 
                src="https://static.readdy.ai/image/8fbfc975813ef59021c9f16b313e86f9/f5810bc36c96b4c4a03e9a9aa341e507.png"
                alt="Assembleia de Deus - Missão Europa"
                className="w-20 h-20 sm:w-24 sm:h-24 lg:w-32 lg:h-32 object-contain shadow-2xl rounded-2xl border-4 border-indigo-200"
              />
              <div className="text-center flex-1">
                <h1 className="text-xl sm:text-2xl lg:text-3xl xl:text-4xl font-bold bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600 bg-clip-text text-transparent whitespace-nowrap">
                  <span style={{ fontFamily: '"Agnes", serif' }}>IGREJA AD MISSÃO EUROPA CHURCH</span>
                </h1>
                <p className="text-sm text-gray-600">Church Portugal</p>
              </div>
            </div>
            
            <nav className="flex items-center space-x-6">
              <button 
                onClick={() => navigate('/home')}
                className="flex items-center space-x-2 px-4 py-2 text-gray-600 hover:text-green-600 hover:bg-green-50 rounded-lg transition-colors whitespace-nowrap"
              >
                <i className="ri-home-line"></i>
                <span>Início</span>
              </button>
              <button 
                onClick={() => navigate('/bible')}
                className="flex items-center space-x-2 px-4 py-2 text-gray-600 hover:text-green-600 hover:bg-green-50 rounded-lg transition-colors whitespace-nowrap"
              >
                <i className="ri-book-line"></i>
                <span>Bíblia</span>
              </button>
              <button 
                onClick={() => navigate('/characters')}
                className="flex items-center space-x-2 px-4 py-2 text-gray-600 hover:text-green-600 hover:bg-green-50 rounded-lg transition-colors whitespace-nowrap"
              >
                <i className="ri-user-star-line"></i>
                <span>Personagens</span>
              </button>
              <button 
                onClick={() => navigate('/radio')}
                className="flex items-center space-x-2 px-4 py-2 text-gray-600 hover:text-green-600 hover:bg-green-50 rounded-lg transition-colors whitespace-nowrap"
              >
                <i className="ri-radio-line"></i>
                <span>Rádio</span>
              </button>
              <button 
                onClick={() => navigate('/kids')}
                className="flex items-center space-x-2 px-4 py-2 text-gray-600 hover:text-green-600 hover:bg-green-50 rounded-lg transition-colors whitespace-nowrap"
              >
                <i className="ri-bear-smile-line"></i>
                <span>Crianças</span>
              </button>
              <button 
                onClick={() => navigate('/devotionals')}
                className="flex items-center space-x-2 px-4 py-2 text-gray-600 hover:text-green-600 hover:bg-green-50 rounded-lg transition-colors whitespace-nowrap"
              >
                <i className="ri-heart-line"></i>
                <span>Devocionais</span>
              </button>
              <button 
                onClick={() => navigate('/studies')}
                className="flex items-center space-x-2 px-4 py-2 text-gray-600 hover:text-green-600 hover:bg-green-50 rounded-lg transition-colors whitespace-nowrap"
              >
                <i className="ri-graduation-cap-line"></i>
                <span>Estudos</span>
              </button>
              <button 
                onClick={() => navigate('/prayer-requests')}
                className="flex items-center space-x-2 px-4 py-2 text-gray-600 hover:text-green-600 hover:bg-green-50 rounded-lg transition-colors whitespace-nowrap"
              >
                <i className="ri-hands-line"></i>
                <span>Oração</span>
              </button>
              <button 
                onClick={() => navigate('/location')}
                className="flex items-center space-x-2 px-4 py-2 text-green-600 bg-green-50 rounded-lg hover:bg-green-100 transition-colors whitespace-nowrap"
              >
                <i className="ri-map-pin-line"></i>
                <span>Localização</span>
              </button>
              <button 
                onClick={handleLogout}
                className="flex items-center space-x-2 px-4 py-2 text-red-600 hover:bg-red-50 rounded-lg transition-colors whitespace-nowrap"
              >
                <i className="ri-logout-box-line"></i>
                <span>Sair</span>
              </button>
            </nav>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <div className="relative h-96 bg-gradient-to-r from-green-600 via-blue-600 to-purple-600 overflow-hidden">
        <div className="absolute inset-0 bg-black/30"></div>
        <img 
          src="https://public.readdy.ai/ai/img_res/f69a238ebeed3dc2c28a5f065fc5bed9.jpg"
          alt="Assembleia de Deus Missão Europa"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="text-center text-white max-w-4xl px-6">
            <h2 className="text-5xl font-bold mb-4">Nossa Localização</h2>
            <p className="text-xl mb-8 opacity-90">
              Venha nos visitar e faça parte da nossa família em Cristo
            </p>
            <button 
              onClick={openGoogleMaps}
              className="bg-white text-green-600 px-8 py-4 rounded-lg font-semibold hover:bg-green-50 transition-colors whitespace-nowrap flex items-center space-x-2 mx-auto"
            >
              <i className="ri-map-pin-line text-xl"></i>
              <span>Ver no Google Maps</span>
            </button>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          {/* Informações da Igreja */}
          <div className="bg-white/95 backdrop-blur-sm rounded-2xl shadow-2xl p-8 border border-white/20">
            <div className="text-center mb-8">
              <div className="w-20 h-20 bg-gradient-to-r from-green-500 to-blue-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-building-line text-3xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold bg-gradient-to-r from-green-600 to-blue-600 bg-clip-text text-transparent mb-2">
                Assembleia de Deus
              </h3>
              <p className="text-xl text-gray-700 font-medium">Missão Europa Church</p>
            </div>

            <div className="space-y-6">
              <div className="flex items-start space-x-4 p-4 bg-gradient-to-r from-green-50 to-blue-50 rounded-lg">
                <div className="w-12 h-12 bg-gradient-to-r from-green-500 to-blue-500 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-map-pin-line text-white text-xl"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-800 mb-1">Endereço</h4>
                  <p className="text-gray-600">
                    Tv. do Parque 7<br />
                    2500-266 Caldas da Rainha<br />
                    Portugal
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4 p-4 bg-gradient-to-r from-blue-50 to-purple-50 rounded-lg">
                <div className="w-12 h-12 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-time-line text-white text-xl"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-800 mb-1">Horários de Culto</h4>
                  <div className="text-gray-600 space-y-1">
                    <p><strong>Domingo:</strong> 10:00 - Culto da Família (Manhã)</p>
                    <p><strong>Domingo:</strong> 19:00 - Culto da Família (Noite)</p>
                    <p><strong>Terça:</strong> 20:00 - Culto de Ensino Bíblico</p>
                    <p><strong>Quinta:</strong> 20:00 - Culto da Vitória</p>
                  </div>
                </div>
              </div>

              <div className="flex items-start space-x-4 p-4 bg-gradient-to-r from-purple-50 to-pink-50 rounded-lg">
                <div className="w-12 h-12 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-phone-line text-white text-xl"></i>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-800 mb-1">Contato</h4>
                  <div className="text-gray-600 space-y-1">
                    <p><strong>Telefone:</strong> +351 262 123 456</p>
                    <p><strong>Email:</strong> contato@missaoeuropa.pt</p>
                    <p><strong>WhatsApp:</strong> +351 912 345 678</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="mt-8 text-center">
              <button 
                onClick={openGoogleMaps}
                className="w-full bg-gradient-to-r from-green-600 to-blue-600 text-white py-4 rounded-lg font-semibold hover:from-green-700 hover:to-blue-700 transition-all duration-200 shadow-xl flex items-center justify-center space-x-2 whitespace-nowrap"
              >
                <i className="ri-navigation-line text-xl"></i>
                <span>Como Chegar - Google Maps</span>
              </button>
            </div>
          </div>

          {/* Mapa Incorporado */}
          <div className="bg-white/95 backdrop-blur-sm rounded-2xl shadow-2xl overflow-hidden border border-white/20">
            <div className="p-6 bg-gradient-to-r from-green-600 to-blue-600 text-white">
              <h3 className="text-xl font-bold flex items-center space-x-2">
                <i className="ri-map-line"></i>
                <span>Localização no Mapa</span>
              </h3>
              <p className="opacity-90 mt-1">Clique no mapa para abrir no Google Maps</p>
            </div>
            
            <div className="relative h-96 cursor-pointer" onClick={openGoogleMaps}>
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3048.5!2d-9.1369!3d39.4034!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMznCsDI0JzEyLjIiTiA5wrAwOCcxMi44Ilc!5e0!3m2!1spt!2spt!4v1234567890"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Assembleia de Deus Missão Europa"
              ></iframe>
              <div className="absolute inset-0 bg-transparent hover:bg-black/10 transition-colors flex items-center justify-center">
                <div className="bg-white/90 backdrop-blur-sm rounded-lg p-4 opacity-0 hover:opacity-100 transition-opacity">
                  <p className="text-gray-800 font-medium flex items-center space-x-2">
                    <i className="ri-external-link-line"></i>
                    <span>Clique para abrir no Google Maps</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Seção de Boas-vindas */}
        <div className="mt-16 bg-white/95 backdrop-blur-sm rounded-2xl shadow-2xl p-8 border border-white/20">
          <div className="text-center mb-8">
            <h3 className="text-3xl font-bold bg-gradient-to-r from-green-600 to-blue-600 bg-clip-text text-transparent mb-4">
              Seja Bem-vindo à Nossa Casa
            </h3>
            <p className="text-xl text-gray-700 max-w-3xl mx-auto">
              A Assembleia de Deus Missão Europa é uma igreja que prega o evangelho completo de Jesus Cristo. 
              Venha fazer parte da nossa família e crescer na fé conosco.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center p-6 bg-gradient-to-r from-green-50 to-blue-50 rounded-xl">
              <div className="w-16 h-16 bg-gradient-to-r from-green-500 to-blue-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-heart-line text-2xl text-white"></i>
              </div>
              <h4 className="text-lg font-semibold text-gray-800 mb-2">Comunhão</h4>
              <p className="text-gray-600">Uma família unida em Cristo, onde todos são bem-vindos</p>
            </div>

            <div className="text-center p-6 bg-gradient-to-r from-blue-50 to-purple-50 rounded-xl">
              <div className="w-16 h-16 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-book-open-line text-2xl text-white"></i>
              </div>
              <h4 className="text-lg font-semibold text-gray-800 mb-2">Ensino</h4>
              <p className="text-gray-600">Pregação fiel da palavra de Deus para edificação</p>
            </div>

            <div className="text-center p-6 bg-gradient-to-r from-purple-50 to-pink-50 rounded-xl">
              <div className="w-16 h-16 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-hands-line text-2xl text-white"></i>
              </div>
              <h4 className="text-lg font-semibold text-gray-800 mb-2">Oração</h4>
              <p className="text-gray-600">Vida de oração e busca constante pela presença de Deus</p>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-gray-900/95 backdrop-blur-sm text-white py-12">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div>
              <div className="flex items-center space-x-3 mb-4">
                <div className="w-10 h-10 bg-gradient-to-r from-green-600 to-blue-600 rounded-full flex items-center justify-center">
                  <i className="ri-building-line text-white"></i>
                </div>
                <h4 className="text-xl font-bold" style={{ fontFamily: '"Pacifico", serif' }}>
                  Bíblia/Missão Europa
                </h4>
              </div>
              <p className="text-gray-300">
                Assembleia de Deus Missão Europa - Levando o evangelho através da tecnologia.
              </p>
            </div>

            <div>
              <h5 className="text-lg font-semibold mb-4">Localização</h5>
              <div className="text-gray-300 space-y-2">
                <p>Tv. do Parque 7</p>
                <p>2500-266 Caldas da Rainha</p>
                <p>Portugal</p>
                <button 
                  onClick={openGoogleMaps}
                  className="text-green-400 hover:text-green-300 transition-colors whitespace-nowrap"
                >
                  Ver no Google Maps →
                </button>
              </div>
            </div>

            <div>
              <h5 className="text-lg font-semibold mb-4">Horários</h5>
              <div className="text-gray-300 space-y-2">
                <p><strong>Dom:</strong> 10:00 e 19:00 - Culto da Família</p>
                <p><strong>Ter:</strong> 20:00 - Ensino Bíblico</p>
                <p><strong>Qui:</strong> 20:00 - Culto da Vitória</p>
                <p className="text-green-400">Todos são bem-vindos!</p>
              </div>
            </div>
          </div>

          <div className="border-t border-gray-700 mt-8 pt-8 text-center text-gray-300">
            <p>&copy; 2024 Assembleia de Deus Missão Europa. Todos os direitos reservados.</p>
            <p className="mt-2">
              <a href="https://readdy.ai/?origin=logo" className="hover:text-white transition-colors">Powered by Readdy</a>
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
